import PastSession from './PastSession';

export default PastSession;
